import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=2bf35843&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=js&"
export * from "./UserPage.vue?vue&type=script&lang=js&"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=2bf35843&scoped=true&lang=scss&"
import style1 from "./UserPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf35843",
  null
  
)

export default component.exports